// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sen-styles-choice-AfSSjUbQ{margin-top:3px;margin-bottom:3px}.sen-styles-body-NvKHj30h{width:370px;padding:24px}`, "",{"version":3,"sources":["webpack://./src/components/SensorReannotateButton/styles.scss"],"names":[],"mappings":"AAAA,4BACE,cAAA,CACA,iBAAA,CAIF,0BACE,WAAA,CACA,YAAA","sourcesContent":[".choice {\n  margin-top: 3px;\n  margin-bottom: 3px;\n}\n\n\n.body {\n  width: 370px;\n  padding: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"choice": `sen-styles-choice-AfSSjUbQ`,
	"body": `sen-styles-body-NvKHj30h`
};
export default ___CSS_LOADER_EXPORT___;
